<template>
  <v-container>
    <v-card>
      <v-toolbar dense color="secondary" flat>
        <v-toolbar-title>
          <span style="color: red">{{ selectedSupplier.Name }}</span> - Supplier
          Statement
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/creditors">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <div>
          <v-row>
            <v-col cols="12" xs="12" md="3">
              <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.StartDate" label="From"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.EndDate" label="To"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="2">
              <v-btn color="primary" :loading="loader" @click="getReport">Query Data</v-btn>
            </v-col>
          </v-row>

          <v-row class="subtitle-2 text--primary">
            <v-col cols="12" xs="12" md="9" class="mb-2">
              <v-btn color="primary" text small @click="printStatement">
                <v-icon left color="black">mdi-printer</v-icon>
                Statement Pdf</v-btn>

               <v-btn color="accent" text small @click="printDetailedStatement">
                <v-icon left color="black">mdi-printer</v-icon>
                Detailed Statement</v-btn>
              <br />

              <div>
                Balance as Of {{ record.StartDate }}:
                <span style="color: red">{{ OpeningBalance | currency }}</span>
              </div>
            </v-col>

            <v-col cols="12" xs="12" md="9">
              <v-text-field v-model="search" dense label="Search"></v-text-field>
              <!-- table headers -->
              <v-data-table dense :headers="headers" :items="jdt1" :search="search">
                <template v-slot:item.DocEntry="{ item }">
                  <v-btn v-if="item.ObjType == 12" text color="primary" @click="openSummaryModal(item.DocEntry)">
                    {{ item.DocEntry }}
                    <v-icon right>mdi-eye</v-icon>
                  </v-btn>

                  <v-btn v-if="item.ObjType == 16" text color="green" @click="getRct1Record(item)">
                    {{ item.DocEntry }}
                    <v-icon right>mdi-eye</v-icon>
                  </v-btn>

                  <v-btn v-if="item.ObjType == 23" text color="red" @click="getReturnRecords(item.DocEntry)">
                    {{ item.DocEntry }}
                    <v-icon right>mdi-eye</v-icon>
                  </v-btn>
                </template>

                <template v-slot:item.Remarks="{ item }">
                  <v-btn v-if="item.ObjType == 14" text color="primary" @click="openSummaryModal(item.DocEntry)">{{
                    item.Remarks }}</v-btn>

                  <v-btn v-if="item.ObjType == 23" text color="red" @click="getReturnRecords(item.DocEntry)">{{
                    item.Remarks }}</v-btn>
                  <v-btn v-if="item.ObjType == 15" text color="green" @click="getRct1Record(item)">{{ item.Remarks
                  }}</v-btn>
                </template>

                <template v-slot:item.InAmount="{ item }">
                  <span v-if="item.InAmount == 0"> - </span>
                  <span v-else>{{ item.InAmount | currency }}</span>
                </template>

                <template v-slot:item.OutAmount="{ item }">
                  <span v-if="item.OutAmount == 0"> - </span>
                  <span v-else>{{ item.OutAmount | currency }}</span>
                </template>

                <template v-slot:item.Balance="{ item }">
                  <span>{{ item.Balance.toLocaleString() }}</span>
                </template>

                <template v-slot:item.DocDate="{ item }">
                  <span>{{ item.DocDate | date }}</span>
                </template>

              </v-data-table>
              <!-- end -->
            </v-col>

            <v-col cols="12" xs="12" md="6" class="mb-2">
              <div>
                Balance as Of {{ record.EndDate }}:
                <span style="color: red">{{ ClosingBalance | currency }}</span>
              </div>
            </v-col>

          </v-row>

          <!-- details modal -->
          <v-dialog v-model="summaryDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card style="background-color: #eceff1">
              <v-toolbar dark color="accent" dense>
                <v-toolbar-title>
                  <v-btn icon dark @click.native="summaryDialog = false">
                    <v-icon dark>mdi-keyboard-backspace</v-icon> </v-btn>Invoice History Details
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click.native="summaryDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text>
                <v-container>
                  <v-row justify="center">
                    <v-col cols="12" xs="12" md="10">
                      <!-- purchases -->
                      <v-card>
                        <v-toolbar color="secondary" dense flat>
                          <v-toolbar-title>Sale Invoice</v-toolbar-title>
                        </v-toolbar>

                        <v-card-text>
                          <v-row dense class="subtitle-2 text--primary">
                            <v-col cols="12" xs="12" sm="12" md="3">
                              <span v-if="oignRecord.ocrd">
                                Supplier: {{ oignRecord.ocrd.Name }}
                                <br />
                                Order number: {{ oignRecord.DocNum }}<br />
                                Date: {{ oignRecord.DocDate }}
                                <br />
                              </span>
                            </v-col>

                            <v-col cols="12" xs="12" sm="12" md="3">
                              <span v-if="oignRecord.ocrd">
                                Total:
                                {{ oignRecord.DocTotal.toLocaleString() }}
                                <br />
                                <!-- Amount Paid:
                                  {{ oignRecord.PaidSum.toLocaleString() }} <br />
                                  Balance:
                                  {{ oignRecord.Balance.toLocaleString() }} -->
                              </span>
                            </v-col>

                            <v-col cols="12" xs="12" sm="12" md="3">
                              <span v-if="oignRecord.ocrd">
                                <span v-if="oignRecord.store">Store: {{ oignRecord.store.Name }}</span>
                              </span>
                            </v-col>

                            <v-col cols="12">
                              <v-text-field v-model="search" label="Search" outlined dense></v-text-field>
                              <v-data-table light :search="search" :items-per-page="100" :headers="oignHeaders"
                                :items="oignRecord.rows" item-key="o_i_t_m_s_id" disable-sort :mobile-breakpoint="0">
                                <template v-slot:item.Name="{ item }">
                                  <span v-if="item.product">{{
                                    item.product.Name
                                  }}</span>
                                </template>
                                <template v-slot:item.Price="{ item }">
                                  <span v-if="item.Price">{{
                                    item.Price.toLocaleString()
                                  }}</span>
                                </template>
                                <template v-slot:item.LineTotal="{ item }">
                                  <span v-if="item.LineTotal">{{
                                    item.LineTotal.toLocaleString()
                                  }}</span>
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                      <!-- end -->
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of details modal -->

          <!-- payments modal -->
          <v-dialog v-model="orctDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card style="background-color: #eceff1">
              <v-toolbar dark color="accent" dense>
                <v-toolbar-title>
                  <v-btn icon dark @click.native="orctDialog = false">
                    <v-icon dark>mdi-keyboard-backspace</v-icon> </v-btn>Payment Details
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click.native="orctDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text>
                <v-container>
                  <v-row justify="center" class="subtitle-2 text--primary">
                    <v-col cols="12" xs="12" md="10" v-if="orctRecord">
                      Date: {{ orctRecord.DocDate }}<br />
                      Amount Paid: {{ orctRecord.CashSum }}
                    </v-col>

                    <v-col cols="12" xs="12" md="10" v-if="orctRecord.rows && orctRecord.rows.length > 0">
                      <v-data-table light :items-per-page="100" :headers="kct2Headers" :items="orctRecord.rows"
                        item-key="id" disable-sort :mobile-breakpoint="0">
                        <template v-slot:item.SumApplied="{ item }">
                          <span>{{
                            item.SumApplied && item.SumApplied.toLocaleString()
                          }}</span>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of payments dialog -->

          <!-- start of sales returns dialog -->
          <v-dialog v-model="returnDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card style="background-color: #eceff1">
              <v-toolbar dark color="accent" dense>
                <v-toolbar-title>
                  <v-btn icon dark @click.native="returnDialog = false">
                    <v-icon dark>mdi-keyboard-backspace</v-icon> </v-btn>Sale Return
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click.native="returnDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text>
                <v-container>
                  <v-row dense justify="center" class="subtitle-2 text--primary" v-if="docReturns">
                    <v-col cols="12" xs="12" sm="12" md="10" style="color: red">
                      <v-card>
                        <v-toolbar color="secondary" dense flat>
                          <v-toolbar-title>Return Details</v-toolbar-title>
                        </v-toolbar>

                        <v-card-text>
                          <v-row class="subtitle-2 text--primary">
                            <v-col cols="12" md="12">
                              <span>
                                Doc Total:
                                {{
                                  docReturns.DocTotal &&
                                  docReturns.DocTotal.toLocaleString()
                                }}
                                <br />
                                Return Date: {{ docReturns.DocDate }}
                                <br />
                              </span>
                            </v-col>

                            <v-col cols="12" md="12">
                              <v-data-table light :items-per-page="100" :headers="returnHeaders"
                                :items="docReturns.rows" item-key="id" disable-sort :mobile-breakpoint="0">
                                <template v-slot:item.product="{ item }">
                                  <span v-if="item.product" style="color: red">{{ item.product.Name }}</span>
                                </template>
                                <template v-slot:item.Quantity="{ item }">
                                  <span style="color: red" v-if="item.Quantity">{{ item.Quantity.toLocaleString()
                                  }}</span>
                                </template>
                                <template v-slot:item.Price="{ item }">
                                  <span style="color: red" v-if="item.Price">{{
                                    item.Price.toLocaleString()
                                  }}</span>
                                </template>
                                <template v-slot:item.LineTotal="{ item }">
                                  <span style="color: red" v-if="item.LineTotal">{{ item.LineTotal.toLocaleString()
                                  }}</span>
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of returns dialog -->

          <!-- start of debt payment dialog -->
          <v-dialog v-model="paymentDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card style="background-color: #eceff1">
              <v-toolbar dark color="accent" dense>
                <v-toolbar-title>
                  <v-btn icon dark @click.native="paymentDialog = false">
                    <v-icon dark>mdi-keyboard-backspace</v-icon> </v-btn>Payment Details
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click.native="paymentDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text>
                <v-container>
                  <v-row dense justify="center" class="subtitle-2 text--primary">
                    <v-col cols="12" xs="12" sm="12" md="10" style="color: red">
                      <v-card>
                        <v-toolbar color="secondary" dense flat>
                          <v-toolbar-title>Payment Details</v-toolbar-title>
                        </v-toolbar>

                        <v-card-text>
                          <v-row class="subtitle-2 text--primary">
                            <v-col cols="12" md="12"> </v-col>

                            <v-col cols="12" md="12">
                              <v-data-table light :items-per-page="100" :headers="rct1Headers" :items="rct1Record"
                                item-key="id" disable-sort :mobile-breakpoint="0">
                                <template v-slot:item.SumApplied="{ item }">
                                  <span style="color: red" v-if="item.SumApplied">{{
                                    item.SumApplied.toLocaleString()
                                  }}</span>
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of payment dialog -->

          <!-- start of payment dialog -->
          <v-dialog v-model="jdt1Dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card style="background-color: #eceff1">
              <v-toolbar dark color="accent" dense>
                <v-toolbar-title>
                  <v-btn icon dark @click.native="jdt1Dialog = false">
                    <v-icon dark>mdi-keyboard-backspace</v-icon> </v-btn>Payment Details
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click.native="jdt1Dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text>
                <v-container>
                  <v-row dense justify="center" class="subtitle-2 text--primary">
                    <v-col cols="12" xs="12" sm="12" md="10" style="color: red">
                      <v-card>
                        <v-toolbar color="secondary" dense flat>
                          <v-toolbar-title>Payment Details</v-toolbar-title>
                        </v-toolbar>

                        <v-card-text>
                          <v-row class="subtitle-2 text--primary">
                            <v-col cols="12" md="12"> </v-col>

                            <v-col cols="12" md="12">
                              <v-data-table light :items-per-page="100" :headers="jdt1Headers" :items="jdt1Records"
                                item-key="id" disable-sort :mobile-breakpoint="0">
                                <template v-slot:item.Debit="{ item }">
                                  <span style="color: red" v-if="item.Debit">{{
                                    item.Debit.toLocaleString()
                                  }}</span>
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of payment dialog -->

          <snackbar ref="snackbar"></snackbar>
        </div>
      </v-card-text>
    </v-card>

    <!-- pdf preview -->
    <pdf-preview ref="pdfPreview"></pdf-preview>
    <!-- end -->

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import { http, host } from "@/common/index";
export default {
  data() {
    return {
      oignRecord: {},
      OpeningBalance: 0,
      ClosingBalance: 0,
      orctDialog: false,
      paymentDialog: false,
      docReturns: {},
      record: {},
      orctRecord: {},
      summaryDialog: false,
      productsDialog: false,
      returnDialog: false,
      jdt1Dialog: false,
      jdt1Records: [],
      selectedSupplier: {},
      saleRecord: {},
      rct1Record: [],
      soldItems: [],
      menu1: false,
      menu2: false,
      search: null,
      loader: false,
      brands: [],
      customers: [],
      stockReport: [],
      categories: [],
      invoicesData: [],
      invoiceLoader: false,
      auditData: {},
      jdt1: [],
      kct2: [],
      headers: [
        { text: "DocEntry", value: "DocEntry" },
        { text: "Transaction", value: "Title" },
        { text: "Debit", value: "InAmount" },
        { text: "Credit", value: "OutAmount" },
        { text: "Balance", value: "Balance" },
        { text: "Date", value: "DocDate" },
      ],
      oignHeaders: [
        { text: "Product", value: "Name" },
        { text: "Qty", value: "Quantity" },
        // { text: "Purchase UOM", value: "UomEntry" },
        { text: "Price", value: "Price" },
        // { text: "Tax", value: "TaxId" },
        { text: "Total", value: "LineTotal" },
        // { text: "Action", value: "action" },
      ],
      returnHeaders: [
        { text: "Product", value: "product" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" },
      ],
      kct2Headers: [
        { text: "Account", value: "oact.Name" },
        { text: "Amount", value: "SumApplied" },
        { text: "Date", value: "created_at" },
      ],
      rct1Headers: [
        { text: "Date", value: "DocDate" },
        { text: "Account", value: "oact.Name" },
        { text: "Amount", value: "SumApplied" },
        { text: "Ref / Transaction Code", value: "PaymentRemarks" }
      ],
      jdt1Headers: [
        { text: "Account", value: "oact.Name" },
        { text: "Amount", value: "Debit" },
        { text: "Date", value: "DocDate" },
      ],
      soldHeaders: [
        { text: "Product", value: "Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "DisplayTotal" },
      ],
    };
  },
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
  },
  watch: {
    "$route.params.id": {
      handler: "singleSupplier",
      immediate: true,
    },
  },
  methods: {
    moreDetails(data) {
      if (data.ObjType == 14) {
        this.getSaleProducts(data.DocEntry);
      }
    },
    openSummaryModal(DocEntry) {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/statement/details/14/${DocEntry}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.oignRecord = res.ResponseData.origDoc;
            self.kct2 = res.ResponseData.payments;
            self.docReturns = res.ResponseData.returns;
            self.$store.commit("loader", false);
            self.summaryDialog = true;
          } else {
            self.$store.commit("loader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("loader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getSaleProducts(val) {
      const self = this;
      this.$store.commit("loader", true);
      self.saleRecord = {};
      this.$store
        .dispatch("get", `/documents/14/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.saleRecord = res.ResponseData;
            const products = [];
            if (res.ResponseData.rows) {
              for (const row of res.ResponseData.rows) {
                row.Name = row.product.Name;
                row.DisplayTotal = row.LineTotal.toLocaleString();
                products.push(row);
              }
              self.soldItems = products;
              self.productsDialog = true;
              this.$store.commit("loader", false);
            }
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReport() {
      const data = this.record;
      data.SupplierId = this.selectedSupplier.id;
      const url = `/supplier-statement`;
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.auditData = res.ResponseData;
            if (res.ResponseData.BpAudit == null) {
              self.jdt1 = [];
            }

            if (res.ResponseData.BpAudit != null) {
              self.jdt1 = res.ResponseData.BpAudit;
            }


            self.OpeningBalance = res.ResponseData.OpeningBalance;
            self.ClosingBalance = res.ResponseData.ClosingBalance;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch((err) => {
          self.$store.commit("loader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDebtPaymentRecords(DocEntry) {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/audit-debt-payments/${DocEntry}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.orctRecord = res.ResponseData;
            self.orctDialog = true;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReturnRecords(DocEntry) {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/credit-memo-details/${DocEntry}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.docReturns = res.ResponseData;
            self.returnDialog = true;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getJdt1Record(id) {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/get-jdt1-record/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.jdt1Records = res.ResponseData;
            self.jdt1Dialog = true;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getRct1Record(item) {
      let data = {};
      data.CardCode = item.CardCode;
      data.DocEntry = item.id;
      const url = "/get-rct1-record";
      const self = this;
      self.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.rct1Record = res.ResponseData;
            self.paymentDialog = true;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    singleSupplier(val) {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/suppliers/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.selectedSupplier = res.ResponseData;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    invSummary() {
      const data = this.record;
      data.CustomerId = this.selectedSupplier.id;
      const url = "/invoices-summary/14";
      const self = this;
      this.invoiceLoader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.invoicesData = res.ResponseData.AllSales;
            self.invoiceLoader = false;
            self.printInvoiceSummary();
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    printStatement() {
      var url = "/print-supplier-statement";
      const apiUrl = `${host}${url}`;
      const self = this;

      var SupplierId = this.selectedSupplier.id;
      const data = this.record;
      data.SupplierId = SupplierId;

      http.post(apiUrl, data, { responseType: "blob" }).then(response => {
        console.log(response.data, " response data");
        const blob = new Blob([response.data], { type: "application/pdf" });
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64data = reader.result;
          self.$refs.pdfPreview.show(base64data);
        };
      });
    },
        printDetailedStatement() {
      var url = "/print-detailed-supplier-statement";
      const apiUrl = `${host}${url}`;
      const self = this;

      var SupplierId = this.selectedSupplier.id;
      const data = this.record;
      data.SupplierId = SupplierId;

      http.post(apiUrl, data, { responseType: "blob" }).then(response => {
        console.log(response.data, " response data");
        const blob = new Blob([response.data], { type: "application/pdf" });
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64data = reader.result;
          self.$refs.pdfPreview.show(base64data);
        };
      });
    },
  },
  created() { },
};
</script>

<style lang="scss" scoped></style>